var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "form",
        {
          staticClass: "modal-card",
          staticStyle: { width: "600px" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.updateReasonCancellation($event)
            }
          }
        },
        [
          _vm._m(0),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _c(
                "div",
                { staticClass: "column is-10" },
                [
                  _c(
                    "BField",
                    { attrs: { label: "Motivo de cancelación" } },
                    [
                      _c(
                        "BSelect",
                        {
                          attrs: { id: "cancellation.reason" },
                          model: {
                            value: _vm.cancellation.reason,
                            callback: function($$v) {
                              _vm.$set(_vm.cancellation, "reason", $$v)
                            },
                            expression: "cancellation.reason"
                          }
                        },
                        _vm._l(_vm.getReasonCancellationCatalog(), function(
                          option
                        ) {
                          return _c(
                            "option",
                            {
                              key: option.key,
                              domProps: { value: option.key }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(option.key) +
                                  " - " +
                                  _vm._s(option.value) +
                                  "\n          "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.cancellation.reason === _vm.cfidWithRelation
                ? [
                    _c(
                      "div",
                      { staticClass: "column" },
                      [
                        _c(
                          "BField",
                          {
                            attrs: {
                              label:
                                "Folio fiscal (UUID) que sustituye al comprobante"
                            }
                          },
                          [
                            _c("BAutocomplete", {
                              staticClass: "searcher-dropdown",
                              attrs: {
                                data: _vm.filteredInvoices,
                                field: "cfdi.complement.digitalTaxStamp.uuid",
                                pattern: _vm.pattern,
                                expanded: "",
                                "open-on-focus": ""
                              },
                              on: {
                                typing: _vm.getFilteredInvoices,
                                select: function(option) {
                                  return (_vm.selected = option)
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(props) {
                                      return [
                                        _c("div", { staticClass: "media" }, [
                                          _c(
                                            "div",
                                            { staticClass: "media-content" },
                                            [
                                              _vm._v(
                                                "\n                  Serie: " +
                                                  _vm._s(
                                                    props.option.cfdi
                                                      .voucherSeries
                                                  ) +
                                                  " -\n                  Folio: " +
                                                  _vm._s(
                                                    props.option.cfdi
                                                      .voucherConsecutive
                                                  ) +
                                                  " "
                                              ),
                                              _c("br"),
                                              _c("strong", [
                                                _vm._v(
                                                  "\n                    UUID: " +
                                                    _vm._s(
                                                      props.option.cfdi
                                                        .complement
                                                        .digitalTaxStamp.uuid
                                                    ) +
                                                    "\n                  "
                                                )
                                              ])
                                            ]
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2953950106
                              ),
                              model: {
                                value: _vm.cancellation.uuids,
                                callback: function($$v) {
                                  _vm.$set(_vm.cancellation, "uuids", $$v)
                                },
                                expression: "cancellation.uuids"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _c(
                "footer",
                { staticClass: "modal-card-foot" },
                [
                  _c(
                    "Button",
                    {
                      staticClass: "button",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$modalForm({ show: false })
                        }
                      }
                    },
                    [_vm._v("\n        Cerrar\n      ")]
                  ),
                  _c(
                    "Button",
                    {
                      staticClass: "button is-secondary",
                      attrs: {
                        type: "submit",
                        disabled: !_vm.cancellation.reason
                      }
                    },
                    [_vm._v("\n        Cancelar documento\n      ")]
                  )
                ],
                1
              )
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title has-text-primary" }, [
        _vm._v("\n      Cancelación de CFDI\n    ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }